<template lang="pug">
div.wrap-item-terms-of-use.relative.overflow-hidden.rounded.px20
  div.wrap-header.absolute.w-full.l0.t0
    HeaderModalWindow(label="利用条件に制限を設定" @closeModalWindow="$emit('closeModalWindow')")
  div.wrap-settings.pt24.mb4
    div.mb12
      v-checkbox(label="暴力表現を含む漫画への利用を禁止" v-model="violenceRepresentation")
    div.mb12
      v-checkbox(label="性的表現を含む漫画への利用を禁止" v-model="sexualRepresentation")
    div.mb12
      v-checkbox(label="法人の商用利用を含む漫画への利用を禁止" v-model="corporateCommercialUse")
    div.mb12
      v-checkbox(label="個人の商用利用を含む漫画への利用を禁止" v-model="individualCommercialUse")
    div.mb24
      v-checkbox(label="クレジット表記必須" v-model="creditNotationUnnecessary")
    v-text-field(label="クレジット表記" v-model="creditNotion"
      @keydown.stop
      placeholder="クレジットを記入"
      persistent-placeholder outlined)
  div.f.flex-right.pb20
    div(@click="onChange").btn.cursor-pointer.f.fh.px24.py6
      span.fz14 変更
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$modal_header_height: 44px;
.wrap-item-terms-of-use {
  padding-top: $modal_header_height;
  background: $primary_bg_color;
  max-width: 380px;
  .btn {
    background: $active_color;
    color: $dark_primary_text_color;
    border-radius: 3px;
  }
}
</style>

<style lang="scss">
.wrap-item-terms-of-use {
  .v-input__slot {
    margin: 0 !important;
  }
  .v-input--selection-controls {
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import HeaderModalWindow from '@/components/shared/HeaderModalWindow'

export default {
  components: {
    HeaderModalWindow
  },
  props: {
    assetType: {
      type: String,
      required: true
    },
    termsOfUse: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      // violenceRepresentation: true,
      // sexualRepresentation: true,
      // individualCommercialUse: true,
      // corporateCommercialUse: true,
      // creditNotationUnnecessary: true,
      violenceRepresentation: false,
      sexualRepresentation: false,
      individualCommercialUse: false,
      corporateCommercialUse: false,
      creditNotationUnnecessary: false,
      creditNotion: ''
    }
  },
  async created () {
    const termsOfUse = this.termsOfUse
    this.violenceRepresentation = !termsOfUse.violenceRepresentation
    this.sexualRepresentation = !termsOfUse.sexualRepresentation
    this.individualCommercialUse = !termsOfUse.individualCommercialUse
    this.corporateCommercialUse = !termsOfUse.corporateCommercialUse
    this.creditNotationUnnecessary = !termsOfUse.creditNotationUnnecessary
    this.creditNotion = termsOfUse.creditNotion
  },
  methods: {
    onChange () {
      const termsOfUse = {
        violenceRepresentation: !this.violenceRepresentation,
        sexualRepresentation: !this.sexualRepresentation,
        individualCommercialUse: !this.individualCommercialUse,
        corporateCommercialUse: !this.corporateCommercialUse,
        creditNotationUnnecessary: !this.creditNotationUnnecessary,
        creditNotion: this.creditNotion
      }
      this.$emit('updateTermsOfUseSettings', termsOfUse)
      this.$emit('closeModalWindow')

      this.$root.$emit('showNavigationMessage', {
        message: '利用条件を変更しました', showOK: true
      })
    }
  }
}
</script>
